import React, {Component} from "react";  import config from 'react-global-configuration';
import {Tab, TabList, TabPanel, Tabs} from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import jwt_decode from "jwt-decode";
import ActiveBtids from 'components/Invoice/ActiveBtids';
import InactiveBtids from 'components/Invoice/InactiveBtids';
import InactiveUtids from 'components/Invoice/InactiveUtids';
import GstList from 'components/Invoice/GstList';
import PartyCode from 'components/Invoice/PartyCode';
import TerminalDetails from 'components/Invoice/TerminalDetails';
import Invoices from 'components/Invoice/Invoices';
import BankSummary from 'components/Invoice/BankSummary';
import BankTransactions from 'components/Invoice/BankTransactions';
import BankTerminalDetails from 'components/Invoice/BankTerminalDetails';
import BankEMI from 'components/Invoice/BankEMI';
import axios from "axios";
import $ from "jquery";
import NotificationSystem from "react-notification-system";
import {css} from "@emotion/core";
import ReactTooltip from 'react-tooltip';
import Select from 'react-select';
import {style} from "variables/Variables.jsx";
import ModalD from "react-awesome-modal";
import ReactMultiSelectCheckboxes from 'react-multiselect-checkboxes';
import {List} from "react-virtualized";


const override = css`
    display: block;
    margin: 0 auto;
    border-color: red;
`;
const overrides = css `
    display: block;
    margin: 0 auto;
    border-color: red;
    text-align:center;
    float:right;
`;
function getMonth(date) {
    var month = date.getMonth() + 1;
    return month < 10 ? '0' + month : '' + month; // ('' + month) for string result
}
const monthNames = ["January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
];
var timestamp = new Date().getTime();
var monthOptions = [];
for(var i=0; i<=11; i++){
    let date2 = new Date();
    let monthd = date2.setMonth(date2.getMonth() -i);
    date2 = date2.toDateString();
    date2 = new Date(date2);
    let month2 = getMonth(date2);
    let year2 = date2.getFullYear();
    let monthName2 = monthNames[date2.getMonth()];
    var isDisable = true;
    if(month2 == '06' || month2 == '07'){
        isDisable = false;
    }

    monthOptions.push({ value: month2+year2, label: monthName2+' '+year2 })
}
//console.log("1stmothoption");
//console.log(monthOptions);

class AdditionalData extends Component{
    constructor(props) {
        super(props);
        this.state ={
            tabsPermissionsArray:[],
            allTabs:["invoice_merchants", "invoice_banks", "invoice_finance"],
            tabsPermissions:[],
            matchedTabs:'',
            merchantList:[],
            chainList:[],
            merchantID:'',
            chainID:'',
            monthID: '042020',
            is_download:true,
            user_id:'',
            merchant_name:'Reliance Retail Limited',
            acqBankList: [{value: '', label: 'All'}],
            acqBankValue: null,
            acq_bank_id: "",
            selected_tab:'Summary',
            merchantValue:null,
            chainValue:null,
            bankValue:null,
            monthValue: {value: '042020', label: 'April 2020'},
            storeID:'',
            storeValue:'',
            storeList:[],
            merchant_list_box: false,
            chain_list_box: false,
            store_list_box: false,
            acq_bank_list_box: false,
            model_visible: false,
            file_url: '',
            rfile: '',
        }
    }

    componentDidMount() {
        const tabsPermissions = localStorage.tabsPermissions;
        const token = localStorage.usertoken;
        const decoded = jwt_decode(token);
        this.setState({
            tabsPermissionsArray:tabsPermissions,
            user_id:decoded._id
        });
        this.tabsPermission();
        this._getAllMerchants();

        var stringCode = decoded.object_code;
        var arrayCode = stringCode.split(",");
        this.setState({
            user_id:decoded._id,
            object_type: decoded.object_type,
            object_code: arrayCode,
        });
        if(decoded.object_type=='Admin' || decoded.object_type=='Innoviti') {
            this._getAcqBanks();
            this.getChain(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            this.getStore(decoded.object_code, 'innoviti', decoded.object_type, decoded.object_code);
            //this.get_filtered_data('', '', this.state.monthID);
            this.setState({
                merchant_list_box: true,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Merchant') {
            this.getChain(arrayCode, 'merchant', decoded.object_type, arrayCode);
            this.getStore(arrayCode, 'merchant', decoded.object_type, arrayCode);
            var merchantData = [];
            arrayCode.map((value, index) => {
                merchantData.push({"value": value, "label": ""})
            })
            this.changeMerchant('merchant', merchantData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: true,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Chain') {
            this.getStore(arrayCode, 'chain', decoded.object_type, arrayCode);
            var chainData = [];
            arrayCode.map((value, index) => {
                chainData.push({"value": value, "label": ""})
            })
            this.changeChain('chain', chainData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: true,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Store') {
            var storeData = [];
            arrayCode.map((value, index) => {
                storeData.push({"value": value, "label": ""})
            })
            this.changeStore('store', storeData);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: true,
            })
        }
        else if(decoded.object_type=='Acquiring Bank') {

            var optionSelected = {"value":arrayCode, "label":"" }
            this.changeBank(optionSelected);
            this.setState({
                merchant_list_box: false,
                chain_list_box: false,
                store_list_box: false,
                acq_bank_list_box: false,
            })
        }
    }



    _getAcqBanks(){
        axios.get(config.get('API_URL') + '/reports/acq-banks/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            },
        }).then(response => {
            var that = this;
            if (Object.keys(response.data.data).length != 0) {
                Object.keys(response.data.data).map(function (key, i) {
                    that.state.acqBankList.push({value: response.data.data[key], label: key})
                });
            }
        });
    }
    _getAllMerchants(){
        axios.get(config.get('API_URL') + '/reports/get-merchant/', {
            headers: {
                Authorization: ` ${localStorage.usertoken}`
            }
        }).then(response => {
            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((merchant, index) => {
                    this.state.merchantList.push({value: merchant.merchant_code, label: merchant.merchant_name})
                });
            }
        });
    }
    changeMerchant(login_type, optionSelected) {
        let value = '';
        let midArray = [];
        if (optionSelected.length < 1) {
            value = null;
            midArray = '';
        } else {
            optionSelected.map((mids, i) => {
                midArray.push(mids.value)
                if (login_type != 'merchant') {
                    var index = this.state.merchantList.findIndex(obj => obj.value == mids.value);
                    this.state.merchantList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            merchantID: midArray,
            chainID:'',
            merchantValue:optionSelected,
            chainValue: [],
            storeID:'',
            storeValue: []
        });
        setTimeout(function(){
            this.refs.childSummary.get_filtered_data(midArray,this.state.chainID, this.state.storeID, this.state.monthID );
        }.bind(this), 200);

        if(this.state.selected_tab=='TerminalDetails') {
            this.refs.childTerminal.get_filtered_data(midArray,this.state.chainID, this.state.storeID, this.state.monthID );
        }
        // if(this.state.selected_tab=='Installation') {
        //     this.refs.childInstallation.get_filtered_data(midArray,this.state.chainID, this.state.storeID, this.state.monthID );
        // }
        // if(this.state.selected_tab=='DeInstallation') {
        //     this.refs.childDeInstallation.get_filtered_data(midArray,this.state.chainID, this.state.storeID,this.state.monthID );
        // }
        // if(this.state.selected_tab=='Invoices') {
        //     this.refs.childInvoices.get_filtered_invoices(midArray, this.state.chainID, this.state.storeID, this.state.monthID);
        // }

        if (login_type == '') {
            this.getChain(midArray, 'merchant', this.state.object_type, this.state.object_code);
            this.getStore(midArray, 'merchant', this.state.object_type, this.state.object_code);
        }
    }


    changeChain(login_type, optionSelected) {
        let value = '';
        let cidArray = [];
        if (optionSelected.length < 1) {
            value = null;
            cidArray = '';
        } else {
            optionSelected.map((cids, i) => {
                cidArray.push(cids.value)
                if (login_type != 'chain') {
                    var index = this.state.chainList.findIndex(obj => obj.value == cids.value);
                    this.state.chainList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            chainID: cidArray,
            chainValue: optionSelected,
            storeID: '',
            storeValue: []
        });
        setTimeout(function(){
            this.refs.childSummary.get_filtered_data(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID );
        }.bind(this), 200);

        if(this.state.selected_tab=='TerminalDetails') {
            this.refs.childTerminal.get_filtered_data(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID );
        }
        // if(this.state.selected_tab=='Installation') {
        //     this.refs.childInstallation.get_filtered_data(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID );
        // }
        // if(this.state.selected_tab=='DeInstallation') {
        //     this.refs.childDeInstallation.get_filtered_data(this.state.merchantID, cidArray, this.state.storeID,this.state.monthID );
        // }
        // if(this.state.selected_tab=='Invoices') {
        //     this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, cidArray, this.state.storeID, this.state.monthID);
        // }




        if (login_type == '') {
            this.getStore(cidArray, 'chain', this.state.object_type, this.state.merchantID);
        }

    }
    getChain(code, type, object_type, object_code) {
        axios.post(config.get('API_URL') + '/reports/get-chain/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                },

            }).then(response => {
            let chalinList = [];
            this.setState({chainID: ''});
            response.data.map((chain, index) => {
                chalinList.push({value: chain.chain_code, label: chain.chain_name})
            });
            this.setState({
                chainList: chalinList
            })
        });
    }

    getStore(code, type, object_type, object_code) {
        axios.post(config.get('API_URL') + '/reports/get-store-filter/', {
                code: code,
                type: type,
                object_type: object_type,
                object_code: object_code
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }

            }).then(response => {
            let storeList = [];
            this.setState({storeID: ''});
            response.data.map((store, index) => {
                storeList.push({value: store.store_code, label: store.store_name})
            });
            this.setState({
                storeList: storeList,
                is_store_loading: false
            })
        });
    }

    changeStore(login_type, optionSelected) {
        let value = '';
        let sidArray = [];
        if (optionSelected.length < 1) {
            value = null;
            sidArray = '';
        } else {
            optionSelected.map((sids, i) => {
                sidArray.push(sids.value)
                if (login_type != 'store') {
                    var index = this.state.storeList.findIndex(obj => obj.value == sids.value);
                    this.state.storeList.move(index, 0).join(',');
                }
            });
        }
        this.setState({
            storeID: sidArray,
            storeValue: optionSelected
        });
        setTimeout(function(){
            this.refs.childSummary.get_filtered_data(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );

        }.bind(this), 200);

        if(this.state.selected_tab=='TerminalDetails') {
            this.refs.childTerminal.get_filtered_data(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );
        }
        // if(this.state.selected_tab=='Installation') {
        //     this.refs.childInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );
        // }
        // if(this.state.selected_tab=='DeInstallation') {
        //     this.refs.childDeInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID );
        // }
        // if(this.state.selected_tab=='Invoices') {
        //     this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, sidArray, this.state.monthID);
        // }

    }



    changeMonth(type, optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        //alert(value);
        this.setState({
            monthID: value,
            monthValue:optionSelected,
        });
        if(type=='merchant'){
            this.refs.childSummary.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            if(this.state.selected_tab=='TerminalDetails') {
                this.refs.childTerminal.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            }
            // if(this.state.selected_tab=='Installation') {
            //     this.refs.childInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            // }
            // if(this.state.selected_tab=='DeInstallation') {
            //     this.refs.childDeInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            // }
            // if(this.state.selected_tab=='Invoices') {
            //     this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, this.state.storeID, value);
            // }
        }
        if(type=='bank'){

                this.refs.bankChildSummary.get_filtered_data_bank(this.state.acq_bank_id,value );

            if(this.state.selected_tab=='BankTransaction') {
                this.refs.bankChildTransaction.get_filtered_bank_tra_data(this.state.acq_bank_id, value);
            }
            if(this.state.selected_tab=='BankTerminal') {
                this.refs.bankChildTerminalRental.get_filtered_bank_tr_rental(this.state.acq_bank_id, value);
            }
            // if(this.state.selected_tab=='BankEMI') {
            //     this.refs.bankChildEMI.get_filtered_bank_emi(this.state.acq_bank_id, value);
            // }
        }
    }

    downLoadExel(e){
        var postDatam = {
            merchant_codes: this.state.merchantID,
            chain_codes: this.state.chainID,
            store_codes: this.state.storeID,
            month: this.state.monthID,
        }
        if (this.state.merchantID.length > 0 || this.state.chainID.length > 0 || this.state.storeID.length > 0) {
            this.setState({
                is_download: false,
                model_visible: true,
                file_url: '',
                rfile: ''
            });
            let xhrBank = $.ajax({
                url:config.get('API_URL')+ "/invoice/merchant_download_excel",
                type: "POST",
                data: postDatam,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (response, status, xhr) {
                    let blob = new Blob([response], {
                        type: "application/xlsx"
                    });
                    let fileName = timestamp + '.xlsx';
                    //let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                    let rfile = fileName.replace(/\"/g, "");
                    //console.log(fileName)
                    // let a = document.createElement('a');
                    // let url = window.URL.createObjectURL(blob);
                    // a.href = url;
                    // a.download = rfile;
                    // a.click();
                    // window.URL.revokeObjectURL(url);
                    let url = window.URL.createObjectURL(blob);
                    this.setState({
                        is_download: true,
                        file_url: url,
                        rfile: rfile
                    })
                }.bind(this)
            });
            this.setState({
                xhrBank: xhrBank
            })

        }
        else {
            alert("Please select Merchant/Chain/Store to download Excel");
        }
    }
    cancelReq(){
        this.state.xhr.abort();
        this.setState({
            is_download:true
        })
    }
    tabsPermission(){
        const token = localStorage.usertoken;
        let tabsPermissions = [];
        const decoded = jwt_decode(token);
        const tokenPermission = localStorage.userPermission;
        const decoded_permission = jwt_decode(tokenPermission);
        let AllaccessPermissions = decoded_permission.accessPermissions;
        AllaccessPermissions.map((permissionName, i) => {
            if(permissionName.access_type=='Tab'){
                tabsPermissions.push(permissionName.access_name);
            }
        });
        this.setState({
            tabsPermissions:tabsPermissions,
        });
        this.getMatch(tabsPermissions,this.state.allTabs);

    }
    getMatch(a, b) {
        var matches = [];

        for ( var i = 0; i < a.length; i++ ) {
            for ( var e = 0; e < b.length; e++ ) {
                if ( a[i] == b[e] ) matches.push( a[i] );
            }
        }
        //alert(matches.length);
        this.setState({
            matchedTabs:matches.length
        })
    }
    triggerChildAlert(){
        this.refs.childTerminal.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"TerminalDetails",
        })
    }
    triggerChildAlertInstallation(){
        this.refs.childInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"Installation",
        })
    }
    triggerChildAlertDeInstallation(){
        this.refs.childDeInstallation.get_filtered_data(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"DeInstallation",
        })
    }
    triggerChildAlertInvoices(){
        this.refs.childInvoices.get_filtered_invoices(this.state.merchantID, this.state.chainID, this.state.storeID, this.state.monthID);
        this.setState({
            selected_tab:"Invoices",
        })
    }
    triggerChildAlertBankTransaction(){
        this.refs.bankChildTransaction.get_filtered_bank_tra_data(this.state.acq_bank_id, this.state.monthID);
        this.setState({
            selected_tab:"BankTransaction",
        })
    }
    triggerChildAlertBankSummary(){
        //this.refs.bankChildSummary.get_filtered_data_bank(this.state.acq_bank_id, this.state.monthID );
        this.setState({
            selected_tab:"BankSummary",
        })
    }
    triggerChildAlertTerminalRental(){
        this.refs.bankChildTerminalRental.get_filtered_bank_tr_rental(this.state.acq_bank_id, this.state.monthID);
        this.setState({
            selected_tab:"BankTerminal",
        })
    }
    triggerChildAlertBankEMI(){
        this.refs.bankChildEMI.get_filtered_bank_emi(this.state.acq_bank_id, this.state.monthID);
        this.setState({
            selected_tab:"BankEMI",
        })
    }


    downLoadExelBank(e){
        var postDataBank = {
            banks_codes: this.state.acq_bank_id,
            month: this.state.monthID,
        }
        if (this.state.acq_bank_id.length < 1) {
            //this.props.handleClick("tr", 3, "Please select a Bank")
            alert("Please select Bank to download Excel");
        }
        else {
            this.setState({
                is_download: false,
                model_visible: true,
                file_url: '',
                rfile: ''
            });
            let xhrBank = $.ajax({
                url:config.get('API_URL')+ "/invoice/bank_download_excel",
                type: "POST",
                data: postDataBank,
                beforeSend: function (request) {
                    request.setRequestHeader("Authorization", localStorage.usertoken);
                },
                xhrFields: {
                    responseType: 'blob'
                },
                success: function (response, status, xhr) {
                    let blob = new Blob([response], {
                        type: "application/xlsx"
                    });
                    let fileName = timestamp + '.xlsx';
                    //let fileName = xhr.getResponseHeader('Content-Disposition').split("=")[1];
                    let rfile = fileName.replace(/\"/g, "");
                    //console.log(fileName)
                    // let a = document.createElement('a');
                    // let url = window.URL.createObjectURL(blob);
                    // a.href = url;
                    // a.download = rfile;
                    // a.click();
                    // window.URL.revokeObjectURL(url);
                    let url = window.URL.createObjectURL(blob);
                    this.setState({
                        is_download: true,
                        file_url: url,
                        rfile: rfile
                    })
                }.bind(this)
            });
            this.setState({
                xhrBank: xhrBank
            })
        }
    }
    downloadFile(e) { //alert(this.state.file_url);
        let a = document.createElement('a');
        a.href = this.state.file_url;
        a.download = this.state.rfile;
        a.click();
        window.URL.revokeObjectURL(this.state.url);
    }
    closeModal() {
        this.state.xhrBank.abort();
        this.setState({
            model_visible: false,
            is_download:true
        });
    }


    changeBank(optionSelected){
        const value = optionSelected === null ? '' : optionSelected.value;
        const label = optionSelected === null ? '' : optionSelected.label;
        this.setState({
            acq_bank_id:value,
            bankValue:optionSelected,
            bank_name: label,
        });
        // console.log("hgdhsgfhsdfsdfsdf");
        // console.log(value);

        if(this.state.selected_tab=='BankTransaction') {
            this.refs.bankChildTransaction.get_filtered_bank_tra_data(value, this.state.monthID);
        }
        if(this.state.selected_tab=='BankTerminal') {
            this.refs.bankChildTerminalRental.get_filtered_bank_tr_rental(value, this.state.monthID);
        }
        if(this.state.selected_tab=='BankSummary') {
            this.refs.bankChildSummary.get_filtered_data_bank(value, this.state.monthID );
        }
        if(this.state.selected_tab=='BankEMI') {
            //this.refs.bankChildEMI.get_filtered_bank_emi(value, this.state.monthID);
        }
        //this.get_bank_name(value);
    }

    render() {


        return(
            <div className="content-invoice pt-5">
                <div className="container-fluid">
                    <div className="row">
                        <NotificationSystem ref="notificationSystem" style={style}/>

                        <div className="col-md-12">
                            <div className="card">
                                <div className="content-invoice ">

                                        <Tabs>
                                            <TabList>
                                                <Tab style={{ }}>GST Master</Tab>
                                                <Tab style={{ }} >UTID</Tab>
                                                <Tab style={{ }}>BTID</Tab>

                                                {/*{financeTab}*/}
                                            </TabList>
                                            <TabPanel>

                                                <Tabs forceRenderTabPanel defaultIndex={0}>
                                                    <TabList>
                                                        <Tab>GST</Tab>
                                                        <Tab>Party Code</Tab>
                                                    </TabList>
                                                    <TabPanel>
                                                        <GstList ref="gstLists"/>
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <PartyCode ref="partyCodes"/>
                                                    </TabPanel>


                                                </Tabs>
                                            </TabPanel>
                                            <TabPanel>
                                                <Tabs forceRenderTabPanel defaultIndex={0}>
                                                    <TabList>

                                                        <Tab>Inactive</Tab>
                                                    </TabList>

                                                    <TabPanel>
                                                        <InactiveUtids ref="InActUtids"/>
                                                    </TabPanel>
                                                </Tabs>
                                            </TabPanel>

                                            <TabPanel>

                                                <Tabs forceRenderTabPanel defaultIndex={0}>
                                                    <TabList>
                                                        <Tab>Active</Tab>
                                                        <Tab>Inactive</Tab>
                                                    </TabList>
                                                    <TabPanel>
                                                        <ActiveBtids ref="ActBtids"/>
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <InactiveBtids ref="InActBtids"/>
                                                    </TabPanel>


                                                </Tabs>
                                            </TabPanel>

                                            <TabPanel>

                                                <Tabs forceRenderTabPanel defaultIndex={0}>
                                                    <TabList>
                                                        <Tab onClick={()=>this.triggerChildAlertBankSummary()}>Activee</Tab>
                                                        <Tab onClick={()=>this.triggerChildAlertBankTransaction()}>Inactivee</Tab>

                                                    </TabList>
                                                    <TabPanel>
                                                        <BankSummary ref="bankChildSummary"/>
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <BankTransactions ref="bankChildTransaction"/>
                                                    </TabPanel>

                                                </Tabs>
                                            </TabPanel>
                                        </Tabs>

                                    <div className="footer">
                                        <div className="stats"><i></i>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default AdditionalData